import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogModel } from 'app/modules/common/components/confirmation-dialog/confirm-dialog-model';
import { ConfirmationDialogComponent } from 'app/modules/common/components/confirmation-dialog/confirmation-dialog.component';
import { SharedService } from 'app/modules/common/services/shared-service';
import moment, { Moment } from 'moment';
import { CoordinatorDoctor } from '../../entities/coordinator-doctor';
import { DoctorVisitDetails, DoctorVisitSaveModel } from '../../entities/doctor-visit';
import { CoordinatorDoctorService } from '../../services/coordinator-doctor.service';
import { AddEditDoctorVisitComponent } from './add-edit-doctor-visit/add-edit-doctor-visit.component';
import Utils from 'app/Utils';

@Component({
    selector: 'app-coordinator-doctor',
    templateUrl: './coordinator-doctor.component.html',
    styleUrls: ['./coordinator-doctor.component.scss'],
    standalone: false
})
export class CoordinatorDoctorComponent implements OnInit {

  public isLoading = false;
  public selectedDate: Moment;
  public doctorList = new Array<CoordinatorDoctor>();
  public doctorVisitList = new Array<DoctorVisitDetails>();

  public selectedVisitId = 0;
  public responsiveOptions: any;

  constructor(
    private dialog: MatDialog,
    private sharedService: SharedService,
    private coordinatorDoctorService: CoordinatorDoctorService) {
    this.responsiveOptions = [
      {
        breakpoint: '1920px',
        numVisible: 8,
        numScroll: 1
      },
      {
        breakpoint: '1810px',
        numVisible: 7,
        numScroll: 1
      },
      {
        breakpoint: '1550px',
        numVisible: 6,
        numScroll: 1
      },
      {
        breakpoint: '1366px',
        numVisible: 5,
        numScroll: 1
      }
    ];
  }

  ngOnInit(): void {
    this.selectedDate = moment.utc();
    this.GetDoctorList();
  }

  public yearChanged(selectedDate: Moment) {
    this.selectedDate = selectedDate;
    this.GetDoctorList();
  }

  public GetDoctorList(): void {
    this.isLoading = true;
    this.coordinatorDoctorService.GetDoctorList().subscribe(res => {
      if (res.code === 0) {
        this.doctorList = res.result;
        this.GetDoctorVisitList();
      } else {
        this.isLoading = false;
        this.sharedService.ShowSnackBar('No se pudo cargar a los médicos del coordinador.');
      }
    }, error => {
      this.isLoading = false;
      console.error(error);
      this.sharedService.ShowSnackBar('Se produjo un error, actualice la página.');
    });
  }

  public GetDoctorVisitList(): void {
    const selectedYear = this.selectedDate.get('year');
    this.coordinatorDoctorService.GetDoctorVisits(selectedYear.toString()).subscribe(res => {
      if (res.code === 0) {
        this.doctorVisitList = res.result;
      } else {
        this.sharedService.ShowSnackBar('No se pudieron cargar las visitas al médico.');
      }
      this.isLoading = false;
    }, error => {
      this.isLoading = false;
      console.error(error);
      this.sharedService.ShowSnackBar('Se produjo un error, actualice la página.');
    });
  }

  public toggleDetails(doctor: CoordinatorDoctor, visitId: number): void {
    doctor.showVisit = doctor.selectedVisitaId !== visitId ? true : !doctor.showVisit;
    doctor.selectedVisitDetails = null;
    doctor.selectedVisitaId = null;
    if (doctor.showVisit) {
      doctor.selectedVisitaId = visitId;
      this.coordinatorDoctorService.GetDoctorVisitDetails(visitId.toString()).subscribe(res => {
        if (res.code === 0) {
          const selected = this.doctorList.filter(e => e.id === doctor.id)[0];
          const selectedIndex = this.doctorList.indexOf(selected);
          selected.selectedVisitDetails = res.result;
          this.doctorList.splice(selectedIndex, 1, selected);
        } else {
          this.sharedService.ShowSnackBar('No se pudieron cargar los detalles de la visita.');
        }
      }, error => {
        console.log(error);
        this.sharedService.ShowSnackBar('Ha ocurrido un error. Por favor intente de nuevo.');
      });
    }
  }

  public onDeleteVisita(selectedId: number): void {
    const message = '¿Eliminar la visita con el médico?';
    const dialogData = new ConfirmDialogModel('Confirmar acción', message);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.isLoading = true;
        this.coordinatorDoctorService.DeleteDoctorVisit(selectedId.toString()).subscribe(res => {
          if (res.code === 0 && res.result) {
            this.GetDoctorList();
            this.sharedService.ShowSnackBar('Visita al médico eliminada correctamente.');
          } else {
            this.sharedService.ShowSnackBar('No se pudo borrar la visita al médico.');
          }
          this.isLoading = false;
        }, error => {
          this.sharedService.ShowSnackBar('Ha ocurrido un error. Por favor intente de nuevo.');
          this.isLoading = false;
        });
      }
    });
  }

  public openAddEditPopup(isEdit: boolean, doctor: CoordinatorDoctor): void {
    const modalRef = this.dialog.open(AddEditDoctorVisitComponent, {
      width: '600px',
    });

    modalRef.componentInstance.saveModel = this.mapVisitaDetailsToSaveModel(isEdit, doctor);

    modalRef.afterClosed().subscribe(isSaved => {
      if (isSaved) {
        this.GetDoctorList();
      }
    });
  }

  private mapVisitaDetailsToSaveModel(isEdit: boolean, doctor: CoordinatorDoctor): DoctorVisitSaveModel {
    const saveModel = new DoctorVisitSaveModel();
    saveModel.DoctorId = doctor.medicoId;
    if (isEdit) {
      saveModel.Id = doctor.selectedVisitDetails.id;
      saveModel.Assistant = doctor.selectedVisitDetails.asistentes;
      saveModel.Comments = doctor.selectedVisitDetails.comentarios;
      saveModel.Coordinator = doctor.selectedVisitDetails.coordinador;
      saveModel.Date = doctor.selectedVisitDetails.realizada;
    } else {
      const currentUser = JSON.parse(Utils.decrypt(localStorage.getItem('currentUser'))) ;
      saveModel.Coordinator = currentUser.coordinador;
    }
    return saveModel;
  }

}
